import {
	ChangeDetectionStrategy,
	Component,
	inject,
	NgZone,
	OnDestroy,
	OnInit,
} from '@angular/core';
import { PluginListenerHandle } from '@capacitor/core';
import {
	NativeShare,
	NativeShareEventType,
	NativeShareShareReceived,
} from '@rea.ch/capacitor-native-share';

import { CLIENT_ENVIRONMENT } from '~app-client/core/tokens';
import { ClientEnvironmentName } from '~app-client/core/types';
import { NewNodeCreationService } from '~app-client-item/node-creation-new/services/node-creation.service';

@Component({
	selector: 'share-reactor',
	template: '',
	styles: [':host { display: none }'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
})
export class ShareReactorComponent implements OnInit, OnDestroy {
	private readonly ngZone = inject(NgZone);
	private readonly environment = inject(CLIENT_ENVIRONMENT);
	private readonly newNodeCreationService = inject(NewNodeCreationService);

	private shareListener?: PluginListenerHandle;

	ngOnInit(): void {
		this.startListeningToShares();
	}

	ngOnDestroy(): void {
		try {
			this.shareListener?.remove();
		} catch (error) {}
	}

	private async startListeningToShares(): Promise<void> {
		await this.handleLastShare();

		this.shareListener = await NativeShare.addListener(
			NativeShareEventType.SHARE_RECEIVED,
			(event) => {
				if (this.environment.environmentName !== ClientEnvironmentName.PRODUCTION) {
					console.debug('SHARE RECEIVED', JSON.stringify(event));
				}
				this.shareHandler(event);
			}
		);
	}

	private async handleLastShare(): Promise<void> {
		try {
			const share = await NativeShare.getLastSharedItems();
			this.shareHandler(share);
		} catch (error) {}
	}

	private shareHandler(event: NativeShareShareReceived): void {
		this.ngZone.run(() => {
			this.newNodeCreationService.handleShare(event);
			NativeShare.clear();
		});
	}
}
